import styled, { css } from 'styled-components';
import themeData from 'utils/theme/themeData';

const { typography } = themeData;

// ###############################################################
// <-------------------------- Common --------------------------->
// ###############################################################
export const LoaderContainer = styled.div`
  position: absolute;
  top: 50%;
  left: 50%;
  margin-top: -38px;
  margin-left: -38px;
`;

export const OrderDetailsTitle = styled(typography.TitleTwoTypography)`
  margin: 0;
  color: ${({ theme }) => theme.colors.black};

  ${({ showCursor }) =>
    showCursor &&
    `
    cursor: pointer;
  `}
`;

export const OrderDetailsText = styled(typography.BodyTextOneRegularTypography)`
  margin: 0;
  color: ${({ theme, blueColor }) => (blueColor && theme.colors.blueMain) || theme.colors.black};

  ${({ showCursor }) =>
    showCursor &&
    `
    cursor: pointer;
  `}
`;

export const OrderDetailsSubText = styled(typography.BodyTextOneRegularTypography)`
  margin: 0;
  color: ${({ theme }) => theme.colors.grey002};
`;
// ###############################################################
// <------------------------ End Common ------------------------->
// ###############################################################

// ###############################################################
// <------------------------- Wrappers -------------------------->
// ###############################################################
export const OrderDetailsNoDataText = styled(typography.TitleOneRegularTypography)`
  margin: 0;
`;

export const OrderDetailsWrapper = styled.div`
  min-height: calc(100vh - 82px);
  height: 100%;
  padding: 0 24px 26px 24px;
  background-color: ${({ theme }) => theme.colors.grey100};
`;

export const OrderDetailsContent = styled.div`
  display: flex;

  & > * + * {
    margin-inline-start: 16px;
  }
`;

export const OrderDetailsContentFirstColumn = styled.div`
  width: calc(28% - 8px);
`;

export const OrderDetailsContentSecondColumn = styled.div`
  width: calc(72% - 8px);
`;

export const OrderDetailsInfoSection = styled.div`
  padding: 24px;
  background-color: white;
  border-radius: 8px;
  box-shadow: 0px 2px 4px rgb(44 53 68 / 8%);
`;

export const OrderDetailsLogsSection = styled.div`
  padding: 24px;
  background-color: white;
  border-radius: 8px;
  box-shadow: 0px 2px 4px rgb(44 53 68 / 8%);
`;

export const OrderDetailsStatusSection = styled.div`
  display: flex;
  align-items: center;
  justify-content: center;
  padding: 24px 0 84px 0;
  background-color: ${({ theme }) => theme.colors.white};
  border-radius: 8px;
  box-shadow: 0px 2px 4px rgb(44 53 68 / 8%);
`;

export const OrderDetailsChemistSection = styled.div`
  display: flex;
  padding: 24px;
  background-color: ${({ theme }) => theme.colors.white};
  border-radius: 8px;
  box-shadow: 0px 2px 4px rgb(44 53 68 / 8%);

  & > * + * {
    margin-inline-start: 16px;
  }
`;

export const OrderDetailsAttachmentSection = styled.div`
  padding: 24px;
  background-color: ${({ theme }) => theme.colors.white};
  border-radius: 8px;
  box-shadow: 0px 2px 4px rgb(44 53 68 / 8%);
`;

export const OrderDetailsAttachResultsSection = styled.div`
  padding: 24px;
  background-color: ${({ theme }) => theme.colors.white};
  border-radius: 8px;
  box-shadow: 0px 2px 4px rgb(44 53 68 / 8%);
`;

export const OrderDetailsNoteSection = styled.div`
  display: flex;
  flex-direction: column;
  padding: 24px;
  background-color: white;
  border-radius: 8px;
  box-shadow: 0px 2px 4px rgb(44 53 68 / 8%);
`;
// ###############################################################
// <----------------------- End Wrappers ------------------------>
// ###############################################################

// ###############################################################
// <------------------------ Order Info ------------------------->
// ###############################################################
export const OrderDetailsInfoNumberSectionWrapper = styled.div`
  display: flex;
  flex-direction: row;
  justify-content: space-between;
`;

export const OrderDetailsInfoNumberInfoWrapper = styled.div`
  width: 216px;
`;

export const OrderDetailsInfoSticker = styled(typography.BodyTextFourRegularTypography)`
  display: flex;
  flex-direction: column;
  align-items: center;
  margin: 0;
  color: ${({ color }) => color};

  &:before {
    content: ${({ icon }) => icon};
    font-family: 'Icomoon';
    font-size: 18px;
  }
`;

export const OrderDetailsInfoBadgesWrapper = styled.div``;

export const OrderDetailsInfoBadges = styled(typography.BodyTextFourRegularTypography)`
  display: inline-block;
  margin: 0;
  margin-right: 4px;
  padding: 2px 6px;
  color: ${({ textColor }) => textColor};
  background-color: ${({ backgroundColor }) => backgroundColor};
  border-radius: 4px;
`;

export const OrderDetailsInfoPatientUserDetailsTitleWrapper = styled.div`
  display: flex;
  align-items: center;
`;

export const OrderDetailsInfoPatientUserDetailsTitleIcon = styled.div`
  margin-inline-start: auto;
  cursor: pointer;
  &:before {
    content: '\\e90a';
    font-family: 'Icomoon';
    font-size: 13px;
    color: ${({ theme }) => theme.colors.grey005};
  }
`;

export const OrderDetailsInfoContent = styled.div`
  display: grid;
  grid-template: 1fr / 96px 1fr;
  grid-column-gap: 8px;
  grid-row-gap: 4px;
  align-items: flex-start;
`;

export const OrderDetailsInfoImgWrapper = styled.div`
  position: relative;
  padding-top: 100%;
`;

export const OrderDetailsInfoImg = styled.img`
  position: absolute;
  width: 100%;
  height: 100%;
  top: 0;
  left: 0;
`;

export const OrderNumberOverlay = styled.div`
  position: fixed;
  bottom: 40px;
  left: 50%;
  margin-left: -10px;
  padding: 15px 30px;
  color: white;
  background-color: rgba(0, 0, 0, 0.6);
  border-radius: 10px;
  z-index: 1;
`;

export const extendOrderDetailsPatientUserInfoLoaderStyle = css`
  margin: auto;
`;
// ###############################################################
// <---------------------- End Order Info ----------------------->
// ###############################################################

// ###############################################################
// <----------------------- Order Status ------------------------>
// ###############################################################
export const OrderDetailsStatusIconWrapper = styled.div`
  position: relative;
`;

export const OrderDetailsStatusIcon = styled.div`
  display: flex;
  align-items: center;
  justify-content: center;
  width: 24px;
  height: 24px;
  background-color: ${({ theme }) => theme.colors.white};
  border: 2px solid ${({ theme }) => theme.colors.grey000};
  border-radius: 50%;
  box-sizing: border-box;

  ${({ color, theme }) =>
    color &&
    `
    background-color: ${color};
    border-color: ${color};

    &:before {
      content: '\\e908';
      font-family: 'Icomoon';
      color: ${theme.colors.white};
    }
  `}
`;

export const OrderDetailsStatusTextWrapper = styled.div`
  position: absolute;
  top: 29px;
  left: 50%;
`;

export const OrderDetailsStatusText = styled(typography.BodyTextOneRegularTypography)`
  position: relative;
  left: -50%;
  margin: 0;
  color: ${({ theme }) => theme.colors.grey005};

  ${({ color }) =>
    color &&
    `
    color: ${color};
  `}
`;

export const OrderDetailsStatusLine = styled.hr`
  width: 55px;
  height: 1px;
  margin: 0;
  border: 0;
  border-bottom: 2px solid ${({ theme }) => theme.colors.grey000};

  ${({ color }) =>
    color &&
    `
    border-color: ${color};
  `}
`;
// ###############################################################
// <--------------------- End Order Status ---------------------->
// ###############################################################

// ###############################################################
// <---------------------- Order Chemist ------------------------>
// ###############################################################
export const OrderDetailsChemistDropdownWrapper = styled.div`
  flex: 1;
`;
// ###############################################################
// <-------------------- End Order Chemist ---------------------->
// ###############################################################

// ###############################################################
// <-------------------- Order Attachment ----------------------->
// ###############################################################
export const OrderDetailsAttachmentWrapper = styled.div`
  display: flex;
  align-items: center;
  cursor: pointer;

  & > * + * {
    margin-inline-start: 16px;
  }
`;

export const OrderDetailsAttachmentImgWrapper = styled.div`
  position: relative;
  width: 80px;
`;

export const OrderDetailsAttachmentImgRatio = styled.div`
  padding-top: 100%;
`;

export const OrderDetailsAttachmentImg = styled.img`
  position: absolute;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
`;

export const OrderDetailsAttachmentImgFullSize = styled.img`
  max-width: 100%;
  max-height: 100vh;
`;

export const OrderDetailsAttachmentInfoWrapper = styled.div``;
// ###############################################################
// <------------------ End Order Attachment --------------------->
// ###############################################################

// ###############################################################
// <------------------- Order Attach Results -------------------->
// ###############################################################
export const OrderDetailsAttachResultsBtnWrapper = styled.div`
  text-align: center;
`;

export const OrderDetailsAttachResultsFilesWrapper = styled.div`
  display: grid;
  grid-template-columns: repeat(7, 1fr);
  gap: 20px;
`;

export const OrderDetailsAttachResultsFileItemWrapper = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
`;

export const OrderDetailsAttachResultsFileItemCopyText = styled(
  typography.BodyTextOneRegularTypography,
)`
  margin: 0;
  cursor: pointer;
`;

export const OrderDetailsAttachResultsFileItem = styled.div`
  position: relative;
  width: 100%;
  cursor: pointer;
`;

export const OrderDetailsAttachResultsFileItemPadding = styled.div`
  padding-top: 100%;
`;

export const OrderDetailsAttachResultsFileImg = styled.img`
  position: absolute;
  width: 100%;
  height: 100%;
  top: 0;

  ${({ opacity }) =>
    opacity &&
    `
    opacity: ${opacity};
  `}
  ${({ blur }) =>
    blur &&
    `
    filter: blur(${blur}px);
  `}
`;

export const OrderDetailsAttachResultsResizedFileImg = styled.img`
  position: absolute;
  max-width: 100%;
  max-height: 100%;
  top: 0;
`;

export const OrderDetailsAttachResultsImgPreview = styled.img`
  max-width: 100%;
  max-height: 100vh;
`;

export const OrderDetailsAttachResultsBtn = styled(typography.BodyTextOneRegularTypography)`
  display: inline-flex;
  align-items: center;
  justify-content: center;
  width: 200px;
  height: 46px;
  color: ${({ theme }) => theme.colors.white};
  background-color: ${({ theme }) => theme.colors.greenMain};
  border: 1px solid ${({ theme }) => theme.colors.greenMain};
  border-radius: 4px;
  cursor: pointer;
`;

export const extendOrderDetailsAttachResultsLoaderStyle = css`
  margin: auto;
`;

export const extendOrderDetailsAttachResultsBtnLoaderStyle = css`
  border: 4px solid white;
  border-top: 4px solid ${({ theme }) => theme.colors.greenMain};
`;
// ###############################################################
// <----------------- End Order Attach Results ------------------>
// ###############################################################

// ###############################################################
// <------------------------ Order Note ------------------------->
// ###############################################################
export const OrderDetailsNoteTextArea = styled.textarea`
  width: 100%;
  height: 56px;
  padding: 8px 12px;
  border: 1px solid ${({ theme }) => theme.colors.grey000};
  border-radius: 4px;
  box-sizing: border-box;
  outline: none;
  vertical-align: top;
  resize: none;

  &::-webkit-input-placeholder {
    font-family: 'Lato';
    font-weight: 400;
    color: ${({ theme }) => theme.colors.grey005};
  }
  &:-moz-placeholder {
    font-family: 'Lato';
    font-weight: 400;
    color: ${({ theme }) => theme.colors.grey005};  
  }
  &::-moz-placeholder {
    font-family: 'Lato';
    font-weight: 400;
    color: ${({ theme }) => theme.colors.grey005};  
  }
  &:-ms-input-placeholder {
    font-family: 'Lato';
    font-weight: 400;
    color: ${({ theme }) => theme.colors.grey005};  
  }
  &::placeholder {
    font-family: 'Lato';
    font-weight: 400;
    color: ${({ theme }) => theme.colors.grey005};  
  }
}
`;

export const OrderDetailsNoteBtn = styled(typography.BodyTextOneRegularTypography)`
  display: flex;
  align-items: center;
  justify-content: center;
  width: 121px;
  height: 38px;
  margin-inline-start: auto;
  color: ${({ theme }) => theme.colors.black};
  background-color: ${({ theme }) => theme.colors.grey100};
  border: 1px solid ${({ theme }) => theme.colors.grey000};
  border-radius: 4px;
  cursor: pointer;
`;
// ###############################################################
// <---------------------- End Order Note ----------------------->
// ###############################################################
// ###############################################################
// <-------------------- Order Visit Note -------------------->
// ###############################################################
export const OrderDetailsVisitNoteSection = styled.div`
  padding: 24px;
  background-color: ${({ theme }) => theme.colors.white};
  border-radius: 8px;
  box-shadow: 0px 2px 4px rgb(44 53 68 / 8%);
`;

export const OrdetVisitNote = styled(typography.BodyTextOneRegularTypography)`
  color: ${({ theme }) => theme.colors.redDark};
`;
// ###############################################################
// <------------------ End Order Visit Note ------------------>
// ###############################################################
// ###############################################################
// <-------------------- Edit Modal -------------------->
// ###############################################################
export const ModalContentWrapper = styled.div`
  padding: 16px 24px 0 24px;
`;

export const FieldWrapper = styled.div`
  padding-bottom: 16px;
`;

export const FieldLabel = styled(typography.TitleTwoTypography)`
  margin: 0;
  color: ${({ theme }) => theme.colors.black};
`;

export const FieldErrorLabel = styled(typography.TitleTwoTypography)`
  margin: 0;
  color: ${({ theme }) => theme.colors.redMain};
`;

export const AddressLabelWrapper = styled.div`
  display: flex;
  flex-direction: row;
  justify-content: flex-start;
`;

export const AddressLabel = styled.div`
  display: flex;
  flex-direction: row;
  justify-content: center;
  align-items: center;
  padding: 8px 12px;
  width: 71px;
  height: 24px;
  background: ${({ theme, selected }) =>
    selected ? theme.colors.blueLight : theme.colors.grey100};
  color: ${({ theme, selected }) => (selected ? theme.colors.blueMain : theme.colors.grey600)};
  border: ${({ theme, selected }) => ` 1px solid  ${selected && theme.colors.blueMain}`};
  border-radius: 4px;
  margin-right: 8px;

  &:hover {
    background: ${({ theme }) => theme.colors.blueLight};
    color: ${({ theme }) => theme.colors.blueMain};
    cursor: pointer;
  }
`;

export const CompleteAddressField = styled.div`
  display: flex;
  justify-content: center;
  align-items: center;
  height: 40px;
  width: 100%;
  background: ${({ theme }) => theme.colors.grey100};
  border-radius: 4px;
`;

// ###############################################################
// <------------------ Edit Modal ------------------>
// ###############################################################
